import React from "react";
import Navigation from "./Navigation";
import { NavLink, withRouter } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
//config url
import configData from "./../../config.js";

class Header2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: require("./../../images/NAKSHEWALA_LOGO-min.png"),
      keywords: [],
      value: "",
      isSearchActive: false,
    };
  }
  selectKeyword = (event) => {
    this.props.history.push(`/search.php?keywords=${event.currentTarget.id}`);
  };

  submitSearch = () => {
    this.props.history.push(`/search.php?keywords=${this.state.value}`);
  };

  handleSearchToggle = () => {
    this.setState({ isSearchActive: !this.state.isSearchActive });
  };

  _handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.props.history.push(`/search.php?keywords=${this.state.value}`);
    }
  }

  handleClick = (event) => {
    this.setState({
      value: event.target.value,
    });
    fetch(`${configData.ADMIN_URL}/api/search?keywords=${event.target.value}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "x-api-key": configData.X_API_KEY,
        "x-api-secret": configData.X_API_SECRET,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            keywords: result.data.keywords,
          });
          
        },
        (error) => {
          console.log(error);
        }
      );
    if (event.key === "Enter") {
      event.preventDefault();
      this.props.history.push(`/search.php?keywords=${event.target.value}`);
    }
    
  };

  componentDidMount() {
    const handleScroll = () => {
      const offset = window.scrollY;

            const stickyheader = document.querySelector('.sticky-header ');

             if (offset >= 70) {
                stickyheader.classList.add('is-fixed');
                stickyheader.classList.add('color-fill');

            } else {
                stickyheader.classList.remove('is-fixed');
                stickyheader.classList.remove('color-fill');
            }
    };

    window.addEventListener("scroll", handleScroll);

    window.updateTopMostParent = (logopath) => {
      this.setState({ logo: logopath });
    };
  }

  render() {
    const { keywords, isSearchActive } = this.state;

    return (
      <>
        <header
          className="site-header nav-wide nav-transparent mobile-sider-drawer-menu"
          id="box1"
        >
          <div className="top-bar sx-bg-secondry">
            <div className="container">
              <div className="d-flex justify-content-between ">
                <ul className="list-unstyled e-p-bx text-white">
                  <li className="supant-phone-no">
                    <a href="mailto:support@nakshewala.com">
                      support@nakshewala.com</a>  <a href="tel:+919312739997">| +91 - 9312739997</a> 
                    
                  </li>
                </ul>
                <ul className="list-unstyled social-bx text-white d-flex flex-wrap align-content-center">
                  <li>
                    <a
                      href="https://www.facebook.com/NaksheWalaOfficial/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-facebook social-icon-top" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/nakshewalaofficial/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-instagram social-icon-top" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@NaksheWalaOfficial"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-youtube social-icon-top" />
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://in.pinterest.com/NakhseWalaOfficial/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-pinterest social-icon-top" />
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
          <div className="sticky-header main-bar-wraper navbar-expand-lg">
            <div className="main-bar mobile">
              <div className="container clearfix">
                {/* Mobile: full-width search bar — covers the header row when active */}
                {isSearchActive && (
                  <div className="mobile-search-bar d-lg-none">
                    <input
                      onChange={this.handleClick}
                      onKeyDown={this._handleKeyDown}
                      value={this.state.value}
                      name="keywords"
                      type="search"
                      autoComplete="off"
                      autoFocus
                      placeholder="Search designs, e.g. 30x40 house design"
                      className="header-search-input"
                    />
                    <button
                      type="button"
                      className="header-search-btn"
                      onClick={this.submitSearch}
                    >
                      <i className="fa fa-search" />
                    </button>
                    <button
                      type="button"
                      className="mobile-search-close"
                      onClick={this.handleSearchToggle}
                      aria-label="Close search"
                    >
                      <i className="fa fa-times" />
                    </button>
                    {keywords.length > 0 && (
                      <div className="header-search-suggestions">
                        <ul>
                          {keywords.map((item) => (
                            <li
                              key={item}
                              id={item}
                              onClick={this.selectKeyword}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
                <div className="logo-header">
                  {/* NAV Toggle Button */}
                  <button
                    data-target=".header-nav"
                    data-toggle="collapse"
                    id="mobile-side-drawer"
                    type="button"
                    className="mobile-side-drawer navbar-toggler collapsed"
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar icon-bar-first" />
                    <span className="icon-bar icon-bar-two" />
                    <span className="icon-bar icon-bar-three" />{" "}
                  </button>
                  <div className="logo-header-inner logo-header-one">
                    <NavLink to={"/"}>
                      <LazyLoadImage
                        effect="blur"
                        src={this.state.logo}
                        alt="NAKSHEWALA_LOGO"
                      />
                    </NavLink>
                  </div>
                </div>

                {/* EXTRA NAV */}
                <div className="extra-nav">
                  {/* Mobile: search icon — opens the full-width search bar */}
                  <div className="extra-cell d-lg-none">
                    <button
                      type="button"
                      className="mobile-search-icon"
                      onClick={this.handleSearchToggle}
                      aria-label="Search"
                    >
                      <i className="fa fa-search" />
                    </button>
                  </div>
                  {/* Desktop: inline search box */}
                  <div className="extra-cell header-search-cell">
                    <div className="header-search-box">
                      <input
                        onChange={this.handleClick}
                        onKeyDown={this._handleKeyDown}
                        value={this.state.value}
                        name="keywords"
                        type="search"
                        autoComplete="off"
                        placeholder="Search designs, e.g. 30x40 house design"
                        className="header-search-input"
                      />
                      <button
                        type="button"
                        className="header-search-btn"
                        onClick={this.submitSearch}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </div>
                    {keywords.length > 0 && (
                      <div className="header-search-suggestions">
                        <ul>
                          {keywords.map((item) => (
                            <li
                              key={item}
                              id={item}
                              onClick={this.selectKeyword}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  {/* Login & Add-to-favourites hidden: OTP login not working.
                  <div className="extra-cell">
                    <NavLink to={"/login"}>
                      <img alt="login" src="/assets/images/user.svg" />
                    </NavLink>
                  </div>
                  <div className="extra-cell">
                    {localStorage.getItem("token") ? (
                      <NavLink to={"/favourite-design"}>
                        <img alt="wishlist" src="/assets/images/heart.svg" />
                      </NavLink>
                    ) : (
                      <NavLink to={"/login"}>
                        <img alt="wishlist" src="/assets/images/heart.svg" />
                      </NavLink>
                    )}
                  </div>
                  */}
                </div>
                {/* EXTRA Nav */}
                {/* MAIN NAVIGATION */}
                <div className="header-nav nav-dark navbar-collapse collapse justify-content-center collapse">
                  <Navigation />
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}

/*window.addEventListener('mouseup', function(event){
    var box = document.getElementById('box1');
    box.classList.remove("active"); 

    const btn = document.getElementById("side_close_mobile");
      btn.onclick = function () {
      if (box.style.display !== "none") {
      box.classList.remove("active"); 
      } else {
       box.style.display = "block";
     }
   };

});*/

export default withRouter(Header2);
